export default __webpack_public_path__ + "static/media/tutorial_preview_road_compliance_checking.15874dc5.png";